import { TTypeOfCodec } from "../../shared/src/codecs/codec";
import { union } from "../../shared/src/codecs/types/union";
import { literal } from "../../shared/src/codecs/types/literal";
import * as util from "../../shared/src/util";

export const ValuationRoute1 = union([
    literal("discovery"),
    literal("instant"),
]);
export type TValuationRoute1Codec = typeof ValuationRoute1;
export type TValuationRoute1 = TTypeOfCodec<TValuationRoute1Codec>;

export const ValuationRoute1_DisplayString = (route: TValuationRoute1): string =>
    route === "discovery" ? "Full valuation (call, and a visit if needed)"
    : route === "instant" ? "Instant valuation (no call, no diary time)"
    : util.requireExhaustive(route);

export const ValuationRoute1_ValRoute = (route: TValuationRoute1): "DISCOVERY" | "INSTANT" =>
    route === "discovery" ? "DISCOVERY"
    : route === "instant" ? "INSTANT"
    : util.requireExhaustive(route);
